// Copyright 2022, Imprivata, Inc.  All rights reserved.

/**
 * Utility functions for handling workflow IDs
 */

/**
 * Generates a new workflow ID using crypto.randomUUID()
 * Falls back to a custom implementation if crypto.randomUUID is not available
 */
export const generateWorkflowId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for environments that don't support crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (c) => {
    const r = Math.trunc(Math.random() * 16);
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

/**
 * Gets the workflow ID from URL search parameters
 */
export const getWorkflowIdFromUrl = (): string | null => {
  if (globalThis.window === undefined) {
    return null;
  }

  const searchParams = new URLSearchParams(globalThis.window.location.search);
  return searchParams.get('Impr-Workflow-Id');
};
